/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Fullpage.js

https://github.com/alvarotrigo/fullPage.js

*/

import 'fullpage.js/dist/jquery.fullpage.min.js';

$(function(){


    function initFullpageSectionScrolling() {
        // init
        const window_width = $(window).width();
        // desktop
        if (window_width >= 991) {
            const $section_scrolling_container = $('.section-scrolling');
            // make sure we do not re-init
            if ($section_scrolling_container.hasClass('fullpage-wrapper') === false || $section_scrolling_container.hasClass('fp-destroyed') === true) {
                // render fullpage
                $section_scrolling_container.fullpage({
                    sectionSelector: '.section-scrolling-enabled',
                    lazyLoading: false,
                    css3: true,
                    scrollBar: true,
                    navigation: true,
                    navigationPosition: 'right',
                    normalScrollElements: '.cms-structure', // enable scrolling in cms structure view
                    afterRender: function(){
                        // re-init section video bg
                        $(window).trigger('initInlineVideo');
                    }
                });
            }
        }
        // mobile: destroy the instance (if it exist) and go back to default section scrolling behaviour
        else {
            if ( $('html').hasClass('fp-enabled') ) {
                $.fn.fullpage.destroy('all');
            }
        }

        // section arrow
        $('.content-section__scroll-arrow--desktop').on('click',function(e){
            e.preventDefault();
            if ( $('html').hasClass('fp-enabled') ) {
                $.fn.fullpage.moveTo(2);
            }
        });
    }

    // on page load
    initFullpageSectionScrolling();

    // custom event
    $(window).on('initFullpageSectionScrolling', function() {
        initFullpageSectionScrolling();
    });

    // initialize again when viewport width has changed
    $(window).on('viewportWidthHasChanged', function(){
        initFullpageSectionScrolling();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/fullpage.js